var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMariquise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 42,
    viewBox: "0 0 25 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.1506 21.0001C24.1506 32.0457 12.6669 41 12.6669 41C12.6669 41 1.18286 32.0457 1.18286 21.0001C1.18286 9.95454 12.6669 1 12.6669 1C12.6669 1 24.1506 9.95454 24.1506 21.0001Z",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.14 21.0002C21.0845 25.3499 17.3123 29.2098 12.6669 32.4733C7.97367 29.2242 4.07647 25.448 1.1936 21.0002C4.2505 16.1174 8.13411 12.3748 12.6667 9.5271C17.3349 12.6514 21.1172 16.5108 24.14 21.0002Z",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.6665 1.43115L12.6668 9.52699L18.7214 7.35173L17.7593 13.4732L22.4542 13.5726L21.8257 17.7609",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.6666 1.198V9.52704L6.70205 7.38401L7.42776 13.4154L3.00659 13.4701L3.38717 17.7609",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.6665 1.43115L12.6668 9.52699L18.7214 7.35173L17.7593 13.4732L22.4542 13.5726L21.8257 17.7609",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.6666 1.59766V9.52693L6.70205 7.3839L7.42776 13.4153L3.00659 13.47L3.38717 17.7608",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.6665 40.4973L12.6668 32.4905L18.7214 34.6658L17.7593 28.5442L22.4542 28.4448L21.8257 24.2566",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.6666 40.4973V32.4905L6.70205 34.6332L7.42776 28.6021L3.00659 28.5474L3.38717 24.2566",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M1.45312 21.0005L5.35593 21.0088",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M5.60994 15.4707L5.35596 21.0088V26.0387",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.6667 32.4906L5.35596 21.0087L12.6667 9.5271",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M1.45312 21.0005L5.35593 21.0088",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M5.60994 15.4707L5.35596 21.0088V26.2695",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.6667 32.4906L5.35596 21.0087L12.6667 9.5271",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M23.8806 21.0029L19.9778 21.0104",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M19.7344 15.6775L19.9777 21.0104L19.9766 26.0403",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M12.6643 32.4906L19.9777 21.0103L12.6694 9.5271",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMariquise);
export default __webpack_public_path__ + "static/media/mariquise.bf9a5e9d194379f12885bbd0e27e57ba.svg";
export { ForwardRef as ReactComponent };